import React from "react";

class StatsBlockContainer extends React.Component {
  render() {
    let styles = {
      container: {
        display: "flex",
        marginLeft: -10
      },
      child: {
        width: "100%",
        marginLeft: 10,
        marginTop: 10,
        boxSizing: "border-box"
      }
    };

    return (
      <div style={Object.assign({}, styles.container, this.props.style)}>
        {this.props.children
          .filter(c => !!c)
          .map((c, i) => {
            return (
              <div
                key={i}
                style={Object.assign({}, styles.child, this.props[`style${i}`])}
              >
                {c}
              </div>
            );
          })}
      </div>
    );
  }
}

export default StatsBlockContainer;



// WEBPACK FOOTER //
// ./src/app/components/partials/stats-block-container.jsx